export interface Settings {
  language: string;
  activeAnonymous: boolean;
  colorScheme: string;
  demoMode: boolean;
  simulateOffline: boolean;
  adminMode: boolean;
  presentationMode: boolean;
  viewedPatients?: string[];
  bookmarkedPatients: string[];
}

export const DEFAULT_SETTINGS: Settings = {
  language: 'de',
  activeAnonymous: false,
  colorScheme: 'default',
  demoMode: false,
  simulateOffline: false,
  adminMode: false,
  presentationMode: false,
  viewedPatients: [],
  bookmarkedPatients: [],
};
